(() => {
  const CARD_SELECTOR = ".product-card[data-ps-pct]";
  const INSERT_AFTER_SELECTOR = ".product-card__name"; // sitio estable
  const PRICE_BLOCK_CLASS = "ps-price";

  const toInt = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
  };

  const getMoneyFormat = () =>
    window.__ps_money_format ||
    window.money_format ||
    (window.Shopify && window.Shopify.money_format) ||
    "${{amount}}";

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }
    const n = (cents / 100).toFixed(2).replace(".", ",");
    return `${n} €`;
  };

  const buildPriceNode = (base, final) => {
    const wrap = document.createElement("div");
    wrap.className = PRICE_BLOCK_CLASS;

    const regular = document.createElement("div");
    regular.className = "product-price product-price--regular";
    regular.innerHTML = `<s>${formatMoney(base)}</s>`;

    const sale = document.createElement("div");
    sale.className = "product-price price-sale";
    sale.textContent = formatMoney(final);

    wrap.appendChild(regular);
    wrap.appendChild(sale);
    return wrap;
  };

  // ✅ Quita el bloque “nativo” que te está metiendo el 3er precio (solo dentro de esta card)
  const hideNativeThemePriceInsideCard = (card) => {
    // bloque típico: <div class="product-card__price"><div class="price ...">...</div></div>
    card.querySelectorAll(".product-card__price .price").forEach((el) => {
      el.style.setProperty("display", "none", "important");
    });

    // si existe el wrapper y NO es nuestro ps-price, lo ocultamos también
    card.querySelectorAll(".product-card__price").forEach((wrap) => {
      if (!wrap.classList.contains(PRICE_BLOCK_CLASS)) {
        wrap.style.setProperty("display", "none", "important");
      }
    });

    // por si existe el bloque antiguo:
    card.querySelectorAll(".product-group-price").forEach((el) => {
      el.style.setProperty("display", "none", "important");
    });
  };

  const applyToCard = (card) => {
    // ya procesada
    if (card.dataset.psDone === "1") return;

    const base = toInt(card.dataset.psBase);
    const final = toInt(card.dataset.psFinal);
    const pct = toInt(card.dataset.psPct);
    if (!pct || !base || !final) return;

    // Marca antes para evitar loops
    card.dataset.psDone = "1";
    card.classList.add("ps-active");

    // ✅ Siempre ocultamos el precio nativo cuando detectamos Private Sale
    hideNativeThemePriceInsideCard(card);

    // Si ya existe, no duplicar
    if (card.querySelector(`.${PRICE_BLOCK_CLASS}`)) return;

    // Insertamos en un sitio que no sea el "price" que el tema recalcula
    const anchor = card.querySelector(INSERT_AFTER_SELECTOR);
    if (!anchor) return;

    const node = buildPriceNode(base, final);
    anchor.insertAdjacentElement("afterend", node);
  };

  const applyAll = (root = document) => {
    root.querySelectorAll(CARD_SELECTOR).forEach(applyToCard);
  };

  const boot = () => {
    applyAll(document);

    const grid =
      document.querySelector("#product-grid") ||
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".js-collection-content-product");

    if (!grid) return;

    const obs = new MutationObserver((mutations) => {
      let needs = false;

      for (const m of mutations) {
        if (m.type !== "childList" || !m.addedNodes?.length) continue;
        for (const n of m.addedNodes) {
          if (!(n instanceof Element)) continue;
          if (n.matches?.(CARD_SELECTOR) || n.querySelector?.(CARD_SELECTOR)) {
            needs = true;
            break;
          }
        }
        if (needs) break;
      }

      if (!needs) return;

      obs.disconnect();
      try {
        // Si el tema re-renderiza y borra nuestro nodo, reinsertamos
        grid.querySelectorAll(CARD_SELECTOR).forEach((card) => {
          // re-aplica ocultación del precio nativo SIEMPRE
          if (toInt(card.dataset.psPct) > 0) {
            card.classList.add("ps-active");
            hideNativeThemePriceInsideCard(card);
          }

          if (!card.querySelector(`.${PRICE_BLOCK_CLASS}`)) {
            card.dataset.psDone = "0";
          }
        });

        applyAll(grid);
      } finally {
        obs.observe(grid, { childList: true, subtree: true });
      }
    });

    obs.observe(grid, { childList: true, subtree: true });

    // Reintentos cortos por si el tema “rehace” a los 2s
    const retry = () => {
      document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
        if (toInt(card.dataset.psPct) > 0) {
          card.classList.add("ps-active");
          hideNativeThemePriceInsideCard(card);
        }
        if (!card.querySelector(`.${PRICE_BLOCK_CLASS}`)) card.dataset.psDone = "0";
      });
      applyAll(document);
    };

    setTimeout(retry, 1200);
    setTimeout(retry, 2600);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
